module.exports = __webpack_public_path__ + "static/media/arrowDown.cdc9f651.svg";